/**
 * Detecta o aplicativo OFICIAL (container Capacitor, repositório teams_app_shell).
 *
 * Diferente de `isEmbeddedWebView()`, que responde "estou dentro de algum
 * WebView" — inclusive o do app de terceiro em React Native. Quando esta função
 * devolve `true`, existe API nativa de verdade disponível em `window.TeamsNative`.
 */
export function isTeamsApp() {
  if (typeof window === "undefined") {
    return false;
  }

  return Boolean(window.TeamsNative && window.TeamsNative.isNative);
}

export function isEmbeddedWebView() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent || "";

  return (
    isTeamsApp() ||
    // `window.ReactNativeWebView` é do aplicativo publicado por terceiro
    // (`com.converta.salesteams` / `id6744412883`). Mantido só para o painel
    // continuar se comportando bem para quem ainda usa aquele aplicativo —
    // não é base de nada.
    Boolean(window.ReactNativeWebView) ||
    /; wv\)/i.test(userAgent) ||
    /\bwv\b/i.test(userAgent) ||
    /WebView/i.test(userAgent) ||
    (/Android/i.test(userAgent) &&
      /Version\/[\d.]+/i.test(userAgent) &&
      !/Chrome\/[\d.]+ Mobile/i.test(userAgent)) ||
    (/iPhone|iPad|iPod/i.test(userAgent) &&
      /AppleWebKit/i.test(userAgent) &&
      !/Safari/i.test(userAgent))
  );
}
